import { Badge, Grid, Icon, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Services/CampaignsEditor/subcomponents/StatusBadge/status-badge.module.scss'

const STATUSES = {
  active: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'campaigns_editor::campaigns.table.badges.active',
  },
  blocked: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'campaigns_editor::campaigns.table.badges.blocked',
  },
  deleted: {
    icon: 'inbox-archive',
    color: 'Label-Fifth',
    bgColor: 'Background-Quaternary',
    label: 'campaigns_editor::campaigns.table.badges.archived',
  },
  date_end: {
    icon: 'status pause',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'campaigns_editor::campaigns.table.badges.date_end_label',
    noWrap: true,
  },
  multiple_reasons: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'campaigns_editor::campaigns.table.badges.multiple_reasons',
  },
}

export const StatusBadge = ({
  resource = 'campaigns',
  status = null,
  statusesMap = null,
  dateEndReached = false,
  ...rest
}) => {
  const showTooltip = useMemo(
    () => dateEndReached && status === 'blocked',
    [dateEndReached, status],
  )

  const badgeStatus = useMemo(
    () =>
      showTooltip
        ? 'multiple_reasons'
        : dateEndReached && status === 'active'
        ? 'date_end'
        : status,
    [showTooltip, dateEndReached, status],
  )

  const MAP = statusesMap ? statusesMap : STATUSES
  const badgeProps = MAP?.[badgeStatus]
  const { t } = useTranslation()

  if (!badgeProps) {
    return null
  }

  const { icon, label, bgColor, color, noWrap = false } = badgeProps

  return (
    <Grid wrap={false} gap={8} alignItems={'center'}>
      <Badge
        {...rest}
        size={'xs'}
        variant={'Body-10'}
        bgColor={bgColor}
        color={color}
        startIcon={<Icon color={color} name={icon} width={16} />}
        noWrap={noWrap}
      >
        {t(label)}
      </Badge>

      {showTooltip && (
        <Tooltip
          title={() => (
            <ol className={styles['reasons-list']}>
              <li>
                {t(
                  `campaigns_editor::${resource}.table.badges.reasons.blocked`,
                )}
              </li>
              <li>
                {t(
                  `campaigns_editor::${resource}.table.badges.reasons.date_end`,
                )}
              </li>
            </ol>
          )}
        >
          <Icon name="information" width={20} />
        </Tooltip>
      )}
    </Grid>
  )
}

StatusBadge.propTypes = {
  resource: PropTypes.string,
  status: PropTypes.string,
  statusesMap: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.object]),
  component: PropTypes.elementType,
  dateEndReached: PropTypes.bool,
}
